import vue, { VNodeData, VNode } from "vue";
import store from "../store";

vue.use(Vue => {
	Vue.directive("tip", {
		bind: (el: any, binding: any, vnode: any) => {
			vnode.key = binding.value;
			el.style.overflow = "hidden";
			el.style.textOverflow = "ellipsis";
			el.style.whiteSpace = "noWrap";
			let isForce: boolean;
			if ((<VNodeData>vnode.data).attrs) {
				if (vnode.data.attrs["visible"] === "" ||
					vnode.data.attrs["visible"] === true) {
					el.style.overflow = "visible";
				}
				// @ts-ignore
				isForce =
					vnode.data.attrs["forceTip"] === "" ||
					vnode.data.attrs["forceTip"] === true ||
					!vnode.data;
			} else isForce = false;
			el.onmouseover = () => {
				if (el.querySelector(".subjectSelect") || el.querySelector(".input-tip")) {
					if (el.querySelector("input").scrollWidth > el.scrollWidth || (isForce && binding.value != "" && binding.value != null)) {
						let rect = el.getBoundingClientRect();
						store.dispatch("setTip", {
							text: binding.value,
							left: rect.left + el.offsetWidth + (isForce ? 20 : 5),
							top: rect.top,
							show: true
						});
					}
				}
				if (
					((el.clientWidth < el.scrollWidth) ||
						(isForce && binding.value != "")) && binding.value
				) {
					let rect = el.getBoundingClientRect();
					store.dispatch("setTip", {
						text: binding.value,
						left: rect.left + el.offsetWidth + (isForce ? 20 : 5),
						top: rect.top,
						show: true
					});
				}
			};
			el.onmouseout = () => {
				store.dispatch("setTip", {
					text: "",
					left: 0,
					top: 0,
					show: false
				});
			};
			el.onclick = () => {
				store.dispatch("setTip", {
					text: "",
					left: 0,
					top: 0,
					show: false
				});
			};
		}
	});
});
